export default {
      id: "volume_up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#volume_up",
      toString: function () {
        return this.url;
      }
    }